/**
 * Error thrown when a storage provider answers a raw HTTP request with a
 * non-2xx status.
 *
 * Adapters that go through an SDK get typed errors for free; the ones that hit
 * the provider REST API with `fetch` need this so callers (the upload queue in
 * particular) can tell a retryable 429/5xx apart from a permanent failure.
 */
export class StorageHttpError extends Error {
  constructor(
    public readonly status: number,
    message: string,
    public readonly body?: string,
  ) {
    super(message);
    Object.setPrototypeOf(this, StorageHttpError.prototype);
    this.name = 'StorageHttpError';
  }
}
